import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

@Component({
  selector: 'app-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss']
})
export class LabelComponent extends ComponentBase implements OnInit {

  constructor() { super() }

  ngOnInit() {
  }

  getValue(): string {
    if(this.attribute.value && this.attribute.value != "") {
      return this.attribute.value
    }

    return this.attribute.key
  }

  getLabelType(): string {
    const labelTypeOpt = this.attribute.options
      .find(opt => opt.key.toLowerCase() === 'labeltype');
    
    return labelTypeOpt ? labelTypeOpt.value.toLowerCase() : 'default';
  }

  showHeaderType(): boolean {
    return this.getLabelType() === 'header';
  }

  getCircleBackgroundColor(): string {
    const colorOpt = this.attribute.options
      .find(opt => opt.key.toLowerCase() === 'color');
    
    if (!colorOpt) return '#e0e0e0';

    // Converte a cor para RGB para poder clarear
    const color = colorOpt.value;
    const r = parseInt(color.slice(1,3), 16);
    const g = parseInt(color.slice(3,5), 16);
    const b = parseInt(color.slice(5,7), 16);

    // Clareia a cor em 20%
    const lightenAmount = 0.2;
    const rLight = Math.min(255, Math.round(r + (255 - r) * lightenAmount));
    const gLight = Math.min(255, Math.round(g + (255 - g) * lightenAmount));
    const bLight = Math.min(255, Math.round(b + (255 - b) * lightenAmount));

    return `rgb(${rLight}, ${gLight}, ${bLight})`;
  }

  getCircleBorderColor(): string {
    const colorOpt = this.attribute.options
      .find(opt => opt.key.toLowerCase() === 'color');
    
    return colorOpt ? colorOpt.value : '#c0c0c0';
  }
}
